/** Public marketing URL — no authentication (see UseRoutes). */
export const FEATURE_OF_THE_WEEK_PUBLIC_PATH = "/feature-of-the-week";

/** Platform admin editor (authenticated super admin only). */
export const FEATURE_OF_THE_WEEK_ADMIN_PATH = "/platform/feature-of-the-week";

export const isFeatureOfTheWeekPublicPath = (pathname = "") => {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return normalized === FEATURE_OF_THE_WEEK_PUBLIC_PATH;
};
